import type { CombinedQuestionStats } from 'src/pages/view-survey/view-survey.types';
import type { SurveySummarySection } from 'src/redux/survey/survey.types';

const COLLAPSE_CHAR_THRESHOLD = 240;

export function isCreativeQuestion(question: CombinedQuestionStats): boolean {
  return question.answers.some((answer) => Boolean(answer.imageUrl));
}

export function hasQuestionSummaryContent(question: CombinedQuestionStats): boolean {
  if (question.summaries?.length) {
    return true;
  }
  return Boolean(question.summarySections?.some((section) => section.summaries.length > 0));
}

export function questionSummarySections(question: CombinedQuestionStats): SurveySummarySection[] {
  if (question.summarySections?.length) {
    return question.summarySections;
  }
  if (question.summaries?.length) {
    return [{ label: 'Summary', summaries: question.summaries }];
  }
  return [];
}

export function questionSummaryTextLength(question: CombinedQuestionStats): number {
  return questionSummarySections(question)
    .flatMap((section) => section.summaries)
    .join(' ')
    .length;
}

export function shouldCollapseQuestionSummary(question: CombinedQuestionStats): boolean {
  const sections = questionSummarySections(question);
  return sections.length > 1 || questionSummaryTextLength(question) > COLLAPSE_CHAR_THRESHOLD;
}
